import audio from '../../../../assets/audio/kids-tracks/Text19.mp3';
import image1 from '../../../../assets/images/games/zdar-kids-game/path/1.webp';
import image2 from '../../../../assets/images/games/zdar-kids-game/path/2.webp';
import image3 from '../../../../assets/images/games/zdar-kids-game/path/3.webp';
import image4 from '../../../../assets/images/games/zdar-kids-game/path/4.webp';
import image5 from '../../../../assets/images/games/zdar-kids-game/path/5.webp';
import image6 from '../../../../assets/images/games/zdar-kids-game/path/6.webp';
import image7 from '../../../../assets/images/games/zdar-kids-game/path/7.webp';

export const step25talk = {
    id: 25,
    title: 'Most',
    taskText: `
        <p>
            Dokázali jsme to! Dřevorubec děkuje a prý zaslechl, že se snažíme zjistit, proč se tomu tady říká Zelená hora. 
            On sám to taky nechápe. Dřív tu všude byly močály. Podle něj by se to tu spíš mělo jmenovat Hnědá hora.
        </p>
        <p>
            Počkej dřevorubče, ještě nikam nechoď a řekni nám, kudy máme jít dál!
        </p>
        <p>
            Máme pokračovat dál až ke kamenným schodům. Do telefonu nám nahrál obrázky abychom se po cestě neztratili.
        </p>
    `,
    cipher: {
        text: `
            Pokračujte po fotkách.
        `,
        images: [image1, image2, image3, image4, image5, image6, image7],
        label: 'Úkol',
    },
    continueButtonText: 'Jsme u vrat',
    points: false,
    audio: audio,
};
